import React from 'react';
import AboutIntro from './components/AboutIntro';
import SkillsSection from './components/SkillsSection';
import TimelineSection from './components/TimelineSection';
import MetaTagsUpdater from '../../components/MetaTagsUpdater';

function About() {
  return (
    <div className="pt-20">
      <MetaTagsUpdater pageKey="About" />
      <div className="max-w-6xl mx-auto px-5 py-8">
        <h1 className="text-4xl font-bold text-center text-text-white mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
          About Me
        </h1>
        <AboutIntro />
        <SkillsSection />
        <TimelineSection />
      </div>
    </div>
  );
}

export default About;